import { useEffect, useState } from 'react'
import _ from 'lodash'
import styled, { css } from 'styled-components'

import { Dropdown } from '../Dropdown'
import { Button } from '../Button'
import { Menu, MenuItem } from '../Menu'
import { Icon } from '../Icons'
import { Image } from '../Image'
import { Dictionary } from '../../utils/types'
import { Text } from '../../components/Text'
import { ellipsisMixin } from '../Text/common'

const StyledDropdown = styled(Dropdown)`
  width: 100%;
  img {
    transform: rotate(90deg);
    transition: all 0.25s ease-in;
  }

  &.opened {
    img {
      transform: rotate(-90deg);
      transition: all 0.25s ease-in;
    }
  }
`

const StyledMenu = styled(Menu)`
  max-height: 200px;
  overflow: auto;
`

const StyledSpan = styled.span`
  ${() => css`
    ${ellipsisMixin}
  `}
`

export type DropdownPickerProps = {
  value?: any
  onChange?: (value?: any) => void
  dataSet?: Dictionary<string>
  renderMenuItemLabel?: (itemKey: string) => string
  buttonText?: string
  center?: boolean
}

const SingleItemText = ({ value, onChange, renderMenuItemLabel }: DropdownPickerProps) => {
  const [mounted, setMounted] = useState<boolean>(false)
  useEffect(() => {
    if (!mounted && onChange && value) {
      setMounted(true)
      onChange([value])
    }
  }, [mounted, onChange, value])
  return <Text>{renderMenuItemLabel?.(value)}</Text>
}

export const DropdownPicker = ({
  dataSet,
  onChange,
  renderMenuItemLabel,
  buttonText,
  center = true
}: DropdownPickerProps) => {
  const [menuVisible, setMenuVisible] = useState(false)
  const dataSetKeys = _.keys(dataSet)
  const [selected, setSelected] = useState({})

  if (dataSetKeys.length === 1) {
    return (
      <SingleItemText
        value={dataSetKeys[0]}
        onChange={onChange}
        renderMenuItemLabel={renderMenuItemLabel}
      ></SingleItemText>
    )
  }

  function toggleSelected(selectionSet: Dictionary<string>, key: string, selectedItems: Dictionary<string>) {
    let currentlySelectedItems: Dictionary<string> = {}
    if (selectedItems[key]) {
      currentlySelectedItems = _.omit(selectedItems, [key])
    } else {
      currentlySelectedItems = { ...selectedItems, [key]: selectionSet[key] }
    }

    setSelected(currentlySelectedItems)
    onChange?.(_.keys(currentlySelectedItems))
  }

  const currentSelectionCount = _.keys(selected).length
  const menu = (
    <StyledMenu variant="primary">
      {_.map(dataSetKeys, k => (
        <MenuItem
          disabled={false}
          icon={_.includes(_.keys(selected), k) ? <Icon type="CheckSquareOutlined" /> : <Icon type="BorderOutlined" />}
          variant="default"
          key={k}
          onClick={() => {
            dataSet && toggleSelected(dataSet, k, selected)
          }}
        >
          {renderMenuItemLabel && renderMenuItemLabel(k)}
        </MenuItem>
      ))}
    </StyledMenu>
  )
  return (
    <StyledDropdown
      open={menuVisible}
      onOpenChange={setMenuVisible}
      trigger={['click']}
      openClassName="opened"
      dropdownRender={() => menu}
    >
      <Button center={center} variant="primary" size="small" onClick={() => setMenuVisible(!menuVisible)}>
        <StyledSpan>
          {buttonText} {currentSelectionCount == 0 ? '...' : '  ( ' + currentSelectionCount + ' )'}
        </StyledSpan>
        <Image alt="arrow-down" type="arrowRightWhite" width="24px" height="24px" />
      </Button>
    </StyledDropdown>
  )
}
